'use client';
import { useEffect } from 'react';
import { sdk } from 'sdk';
import useGTM from '../useGTM';

export const useSDKErrorTracking = () => {
  const { error404Event } = useGTM();

  useEffect(() => {
    const handleSDKError = (event: any) => {
      const { data } = event;

      // Check if it's a 404 error from an API call
      if (data?.response?.status === 404 || data?.statusCode === 404) {
        const actionName = data?.actionName || data?.method || 'unknown';
        const endpoint = data?.url || data?.endpoint;

        error404Event(actionName, endpoint);
      }
    };

    // Listen for action errors (BFF API calls)
    sdk.on('actionErrorCaught', handleSDKError);

    // Listen for page API errors
    sdk.on('pageApiErrorCaught', handleSDKError);

    // General error handler as fallback
    sdk.on('errorCaught', handleSDKError);

    return () => {
      sdk.off('actionErrorCaught', handleSDKError);
      sdk.off('pageApiErrorCaught', handleSDKError);
      sdk.off('errorCaught', handleSDKError);
    };
  }, [error404Event]);
};
